import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BtnBar, SuccessAlert, CtaBtn, SecondaryBtn } from '@tmapy/style-guide';

import { Link } from '../../link';
import { useHistoryAction } from '../../hooks';
import { newOrderMessages } from './orderMessages';
import { PageTitle } from '../../app/components/PageTitle';
import { MainContent } from '../../app/components/MainContent';

export const NewOrderSuccess: React.FC<{ orderId: string | number }> = ({ orderId }) => {
  const goToVydejOrderList = useHistoryAction('vydejOrderList');
  const goToVydejOrderDetail = useHistoryAction('vydejOrderDetail', { id: orderId });
  const goToNewOrder = useHistoryAction('vydejNewOrder');

  return (
    <MainContent>
      <article className='sg-u-vs-4'>
        <header>
          <PageTitle>
            <FormattedMessage {...newOrderMessages.pageTitle} />
          </PageTitle>
        </header>
        <div className='sg-u-vs-2'>
          <SuccessAlert size="med">
            <FormattedMessage
              {...newOrderMessages.queryStateSuccess}
              values={{
                orderListLink: (
                  <Link to='vydejOrderList' severity='underlined'>
                    <FormattedMessage {...newOrderMessages.orderListLink} />
                  </Link>
                ),
                orderDetailLink: (
                  <Link to='vydejOrderDetail' params={{ id: orderId }} severity='underlined'>
                    <FormattedMessage {...newOrderMessages.orderDetailLink} />
                  </Link>
                ),
              }}
            />
          </SuccessAlert>
          <BtnBar align='left'>
            <CtaBtn onClick={goToVydejOrderDetail}>
              <FormattedMessage {...newOrderMessages.orderDetailBtn} />
            </CtaBtn>
            <SecondaryBtn onClick={goToNewOrder}>
              <FormattedMessage {...newOrderMessages.newOrderBtn} />
            </SecondaryBtn>
            <SecondaryBtn onClick={goToVydejOrderList}>
              <FormattedMessage {...newOrderMessages.orderListBtn} />
            </SecondaryBtn>
          </BtnBar>
        </div>
      </article>
    </MainContent>
  );
};
